import React, { useState } from 'react';
import {
  Ticket, Star, Trophy, Tv2, Monitor, Users, Megaphone, Gift, Car, Smartphone,
  Watch, Headphones, Shield, Award, Zap, Flag, Target, Crown, Medal, Gem,
  Camera, Mic, Radio, Wifi, Globe, MapPin, Building2, Sparkles, Flame, Heart
} from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

const ICON_OPTIONS = [
  { name: 'ticket', icon: Ticket, label: 'Ticket' },
  { name: 'star', icon: Star, label: 'Star' },
  { name: 'trophy', icon: Trophy, label: 'Trophy' },
  { name: 'tv', icon: Tv2, label: 'TV/Screen' },
  { name: 'monitor', icon: Monitor, label: 'Monitor' },
  { name: 'users', icon: Users, label: 'People' },
  { name: 'megaphone', icon: Megaphone, label: 'Megaphone' },
  { name: 'gift', icon: Gift, label: 'Gift' },
  { name: 'car', icon: Car, label: 'Car' },
  { name: 'smartphone', icon: Smartphone, label: 'Phone' },
  { name: 'watch', icon: Watch, label: 'Watch' },
  { name: 'headphones', icon: Headphones, label: 'Headphones' },
  { name: 'shield', icon: Shield, label: 'Shield' },
  { name: 'award', icon: Award, label: 'Award' },
  { name: 'zap', icon: Zap, label: 'Zap' },
  { name: 'flag', icon: Flag, label: 'Flag' },
  { name: 'target', icon: Target, label: 'Target' },
  { name: 'crown', icon: Crown, label: 'Crown' },
  { name: 'medal', icon: Medal, label: 'Medal' },
  { name: 'gem', icon: Gem, label: 'Diamond' },
  { name: 'camera', icon: Camera, label: 'Camera' },
  { name: 'mic', icon: Mic, label: 'Mic' },
  { name: 'radio', icon: Radio, label: 'Radio' },
  { name: 'wifi', icon: Wifi, label: 'WiFi' },
  { name: 'globe', icon: Globe, label: 'Globe' },
  { name: 'map-pin', icon: MapPin, label: 'Location' },
  { name: 'building', icon: Building2, label: 'Building' },
  { name: 'sparkles', icon: Sparkles, label: 'Sparkles' },
  { name: 'flame', icon: Flame, label: 'Flame' },
  { name: 'heart', icon: Heart, label: 'Heart' },
];

export function getIconComponent(iconName) {
  const found = ICON_OPTIONS.find(i => i.name === iconName);
  return found ? found.icon : null;
}

export function RightIcon({ iconUrl, size = 20, className = '' }) {
  if (!iconUrl) return null;
  // Check if it's a lucide icon name (no "/" or "data:")
  if (!iconUrl.includes('/') && !iconUrl.startsWith('data:')) {
    const IconComp = getIconComponent(iconUrl);
    if (IconComp) return <IconComp size={size} className={className} />;
    return null;
  }
  // Otherwise it's an image URL (data URI or regular URL)
  return <img src={iconUrl} alt="" className={`object-contain ${className}`} style={{ width: size, height: size }} />;
}

export default function IconPicker({ value, onChange, onClose, open }) {
  const [selected, setSelected] = useState(value || '');

  return (
    <Dialog open={open} onOpenChange={v => !v && onClose()}>
      <DialogContent className="bg-white border-gray-200 max-w-sm">
        <DialogHeader>
          <DialogTitle className="text-base font-semibold text-gray-900">Choose Icon</DialogTitle>
        </DialogHeader>
        <div className="grid grid-cols-6 gap-2 mt-3">
          {ICON_OPTIONS.map(opt => {
            const Icon = opt.icon;
            const isSelected = selected === opt.name;
            return (
              <button
                key={opt.name}
                data-testid={`icon-option-${opt.name}`}
                onClick={() => setSelected(opt.name)}
                className={`flex flex-col items-center gap-1 p-2.5 rounded-lg border transition-all text-xs
                  ${isSelected
                    ? 'border-gray-900 bg-gray-900 text-white'
                    : 'border-gray-200 hover:border-gray-400 text-gray-600 hover:bg-gray-50'
                  }`}
                title={opt.label}
              >
                <Icon size={20} />
              </button>
            );
          })}
        </div>
        <div className="flex justify-end gap-2 mt-4">
          <Button variant="outline" size="sm" onClick={onClose} className="border-gray-300">Cancel</Button>
          {value && (
            <Button variant="outline" size="sm" onClick={() => { onChange(''); onClose(); }} className="border-red-300 text-red-600 hover:bg-red-50">
              Remove
            </Button>
          )}
          <Button size="sm" onClick={() => { onChange(selected); onClose(); }} disabled={!selected} className="bg-gray-900 hover:bg-gray-800">
            Select
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
